export enum NavigationSidebarMenuItemIdentifier {
  // Top-level sections
  Home = 'HOME',
  MyOrganisation = 'MY_ORGANISATION',
  Repayments = 'REPAYMENTS',
  RepaymentsAndReconciliation = 'REPAYMENTS_AND_RECONCILIATION',
  FinanceRequestWorkflow = 'FINANCE_REQUEST_WORKFLOW',
  InstrumentUpload = 'INSTRUMENT_UPLOAD',
  InstrumentUploadSection = 'INSTRUMENT_UPLOAD_SECTION',
  TransactionWorkflow = 'TRANSACTION_WORKFLOW',
  CreditNotes = 'CREDIT_NOTES',
  PayerApproval = 'PAYER_APPROVAL',
  RequestFinance = 'REQUEST_FINANCE',
  Disbursements = 'DISBURSEMENTS',
  FunderApprovals = 'FUNDER_APPROVALS',
  CompanyOnboarding = 'COMPANY_ONBOARDING',
  ProductManagement = 'PRODUCT_MANAGEMENT',
  FxAndFloatingRates = 'FX_AND_FLOATING_RATES',
  AdditionalSettings = 'ADDITIONAL_SETTINGS',
  Payments = 'PAYMENTS',
  DigitalContracts = 'DIGITAL_CONTRACTS',

  // Menu items
  Dashboard = 'DASHBOARD',
  Companies = 'COMPANIES',
  ProductGroups = 'PRODUCT_GROUPS',
  ProductStructures = 'PRODUCT_STRUCTURES',
  FloatingRates = 'FLOATING_RATES',
  FXRates = 'FX_RATES',
  ProgrammesAndDeals = 'PROGRAMMES_AND_DEALS',
  BankHolidayRules = 'BANK_HOLIDAY_RULES',
  NotificationTemplates = 'NOTIFICATION_TEMPLATES',
  CreditNoteRules = 'CREDIT_NOTE_RULES',
  Programmes = 'PROGRAMMES',
  Deals = 'DEALS',
  SelfOnboarding = 'SELF_ONBOARDING',
  Notifications = 'NOTIFICATIONS',
  UserManagement = 'USER_MANAGEMENT',
  ServiceAccountManagement = 'SERVICE_ACCOUNT_MANAGEMENT',
  ScheduledJobs = 'SCHEDULED_JOBS',
  AuditTrail = 'AUDIT_TRAIL',
  CompanyNotifications = 'COMPANY_NOTIFICATIONS',
  AllocatedCreditNotes = 'ALLOCATED_CREDIT_NOTES',
  PayerApprovalMaker = 'PAYER_APPROVAL_MAKER',
  PayerApprovalChecker = 'PAYER_APPROVAL_CHECKER',
  PayerApprovalRejected = 'PAYER_APPROVAL_REJECTED',
  MarkAsPaidWithoutFinancing = 'MARK_AS_PAID_WITHOUT_FINANCING',
  RequestAsSeller = 'REQUEST_AS_SELLER',
  RequestAsPayer = 'REQUEST_AS_PAYER',
  SellerFinanceRequestMaker = 'SELLER_FINANCE_REQUEST_MAKER',
  SellerFinanceRequestChecker = 'SELLER_FINANCE_REQUEST_CHECKER',
  SellerFinanceRequestRejected = 'SELLER_FINANCE_REQUEST_REJECTED',
  PayerFinanceRequestMaker = 'PAYER_FINANCE_REQUEST_MAKER',
  PayerFinanceRequestChecker = 'PAYER_FINANCE_REQUEST_CHECKER',
  PayerFinanceRequestRejected = 'PAYER_FINANCE_REQUEST_REJECTED',
  ReadyForFunding = 'READY_FOR_FUNDING',
  CompanySsoSettings = 'COMPANY_SSO_SETTINGS',
  CustomerCompanyDetails = 'CUSTOMER_COMPANY_DETAILS',
  MasterRegistrationForm = 'MASTER_REGISTRATION_FORM',
  CompanySecuritySettings = 'COMPANY_SECURITY_SETTINGS',
  IncomingPayments = 'INCOMING_PAYMENTS',
  WebhookManagement = 'WEBHOOK_MANAGEMENT',
  SystemHealthNotifications = 'SYSTEM_HEALTH_NOTIFICATIONS',
  Disbursement = 'DISBURSEMENT',
  DisbursementConfirmation = 'DISBURSEMENT_CONFIRMATION',
  DisbursementFiles = 'DISBURSEMENT_FILES',
  FunderApprovalMaker = 'FUNDER_APPROVAL_MAKER',
  FunderApprovalChecker = 'FUNDER_APPROVAL_CHECKER',
  FunderApprovalRejected = 'FUNDER_APPROVAL_REJECTED',
  PortalAdminFunderApprovalMaker = 'PORTAL_ADMIN_FUNDER_APPROVAL_MAKER',
  PortalAdminFunderApprovalChecker = 'PORTAL_ADMIN_FUNDER_APPROVAL_CHECKER',
  PortalAdminFunderApprovalRejected = 'PORTAL_ADMIN_FUNDER_APPROVAL_REJECTED',
  RejectedByFunder = 'REJECTED_BY_FUNDER',
  OutstandingInstruments = 'OUTSTANDING_INSTRUMENTS',
  NplStatusApprovals = 'NPL_STATUS_APPROVALS',
  ContractTemplates = 'CONTRACT_TEMPLATES',
  CustomFields = 'CUSTOM_FIELDS',
  Changelog = 'CHANGELOG',
  TransactionLimits = 'TRANSACTION_LIMITS',
  Help = 'HELP',
  ReportingModule = 'REPORTING_MODULE',
}
